import React from 'react';
import type { TutorialStepT } from '../../../common/types/types';
const annotationTimeline: Omit<TutorialStepT, 'getTarget'> = {
  version: 1,
  id: 'annotation-timeline',
  isRoot: true,
  render: () => <div>Annotation time line render annotations created on different frames.</div>
};
const interpolateAnnotation: Omit<TutorialStepT, 'getTarget'> = {
  version: 1,
  id: 'interpolate-annotation',
  render: () => <div>Click on the diamond to open the interpolation popover.</div>,
  disableNext: true
};
const lastInterpolationFrame: Omit<TutorialStepT, 'getTarget'> = {
  version: 1,
  id: 'last-interpolation-frame',
  render: () => <div>Enter the last annotation frame in text box and click on submit.</div>,
  disableNext: true
};
export const VIDEO_TUTORIAL_CONFIG = ({
  annotationTimeline: {
    ...annotationTimeline,
    nextId: interpolateAnnotation.id
  },
  interpolateAnnotation: {
    ...interpolateAnnotation,
    nextId: lastInterpolationFrame.id
  },
  lastInterpolationFrame: {
    ...lastInterpolationFrame
  }
} as const);
export const INTERPOLATION_TUTORIAL_NAME = 'Annotation Interpolation';
export const NO_ANNOTATION_ERROR_MESSAGE = 'Please create at least one annotation in this frame to trigger the tutorial';